import { cleanPhone, looksLikePhone } from "@/lib/phone-mask";
import { escapeForIlikePattern } from "@/lib/utils";

/**
 * O PostgREST separa os ramos de `or=(...)` por vírgula, então um termo digitado que
 * contenha vírgula ("Silva, João") quebra o parse da expressão INTEIRA: a query devolve
 * 400/PGRST100 ("failed to parse logic tree") — a busca morre, não volta vazia.
 * Envolver o valor em aspas duplas resolve (parênteses e espaço não quebram, só a vírgula).
 *
 * Dentro das aspas a barra invertida escapa o próximo caractere (`"a\%b"` chega como
 * `a%b`), então `\` precisa ser dobrado e `"` escapado para sobreviver ao parser.
 */
export function orValue(value: string): string {
  return `"${value.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}

/**
 * Valor pronto para `campo.ilike.<...>` dentro de `.or()`: `%termo%` com os curingas
 * (`%`, `_`) do termo escapados e o todo entre aspas.
 */
export function ilikeOrValue(term: string): string {
  return orValue(`%${escapeForIlikePattern(term)}%`);
}

/**
 * Igual a {@link ilikeOrValue}, mas reduz o termo a dígitos quando ele parece um telefone:
 * `leads.phone`/`companies.phone` guardam só dígitos (trigger `normalize_phone_leads`),
 * então o termo com máscara — "(15) 99772-5616" — nunca casa no ILIKE.
 */
export function phoneIlikeOrValue(term: string): string {
  return looksLikePhone(term) ? orValue(`%${cleanPhone(term)}%`) : ilikeOrValue(term);
}
